import React, { memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Add from '@mui/icons-material/Add';
import Refresh from '@mui/icons-material/Refresh';
import { pillButtonSx } from './styles';

const spinningSx = {
  '@keyframes dashboardRefreshSpin': { to: { transform: 'rotate(360deg)' } },
  animation: 'dashboardRefreshSpin .8s linear infinite',
};

interface DashboardHeaderProps {
  refreshing: boolean;
  onRefresh: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ refreshing, onRefresh }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
    <Box>
      <Typography component="h1" sx={{ fontSize: 32, fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
        Dashboard
      </Typography>
      <Typography sx={{ mt: 0.75, color: 'text.secondary', fontSize: 14 }}>Export and label jobs across your partners</Typography>
    </Box>
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button
        variant="outlined"
        onClick={onRefresh}
        aria-busy={refreshing}
        startIcon={<Refresh sx={refreshing ? spinningSx : undefined} />}
        sx={{ ...pillButtonSx, fontWeight: 500, color: 'text.secondary', borderColor: 'divider', bgcolor: 'background.paper' }}
      >
        Refresh
      </Button>
      <Button variant="contained" component={RouterLink} to="/export" startIcon={<Add />} sx={pillButtonSx}>
        New export
      </Button>
    </Box>
  </Box>
);

export default memo(DashboardHeader);
